<div class="error-dialog-container">
  <!-- Icon -->
  <div class="flex justify-center mb-4">
    <div class="w-14 h-14 rounded-full flex items-center justify-center"
         [ngClass]="errorInfo?.showTroubleshooting ? 'bg-amber-50' : 'bg-rose-50'">
      <ion-icon
        [name]="errorInfo?.showTroubleshooting ? 'warning-outline' : 'close-circle-outline'"
        class="text-3xl"
        [ngClass]="errorInfo?.showTroubleshooting ? 'text-amber-500' : 'text-rose-500'">
      </ion-icon>
    </div>
  </div>

  <!-- Title -->
  <h3 class="text-lg font-semibold text-gray-900 text-center mb-2">
    {{ errorInfo?.title || errorInfo?.heading || 'Error' }}
  </h3>

  <!-- Message -->
  <p class="text-sm text-gray-500 text-center leading-relaxed mb-5">
    {{ errorInfo?.message || 'An error occurred. Please try again.' }}
  </p>

  <!-- Troubleshooting (charging errors only) -->
  @if (errorInfo?.showTroubleshooting) {
    <div class="space-y-3 mb-5">
      <div class="px-3.5 py-3 rounded-lg bg-gray-50 border border-gray-100">
        <h4 class="text-sm font-semibold text-gray-800 mb-2">Option 1: Unplug and Reconnect</h4>
        <p class="text-xs text-gray-500 mb-1.5">1. Remove the charging gun from your car.</p>
        <p class="text-xs text-gray-500 mb-1.5">2. Place the gun back onto the charger.</p>
        <p class="text-xs text-gray-500">3. Wait a moment and then try resuming the charge.</p>
      </div>
      <div class="px-3.5 py-3 rounded-lg bg-gray-50 border border-gray-100">
        <h4 class="text-sm font-semibold text-gray-800 mb-2">Option 2: Restart Charger</h4>
        <p class="text-xs text-gray-500 mb-1.5">1. Locate the restart button or switch on the charging station.</p>
        <p class="text-xs text-gray-500 mb-1.5">2. Press or switch it to restart the charger.</p>
        <p class="text-xs text-gray-500">3. Wait for the restart to complete and try resuming the charge.</p>
      </div>
    </div>
  }

  <!-- Support link -->
  @if (errorInfo?.showTroubleshooting) {
    <p class="text-xs text-gray-400 text-center mb-4">
      Still having issues?
      <a href="mailto:hello@spotcharge.co.in" class="text-primary font-medium">Contact Support</a>
    </p>
  }

  <!-- Action button -->
  <button
    class="w-full py-3 rounded-xl font-medium text-sm text-white bg-primary"
    (click)="confirm()">
    {{ errorInfo?.showTroubleshooting ? 'Got It' : 'OK' }}
  </button>
</div>
